import type { RunCourseState, RunCourseEditState, RunCourseUiState } from '@/models/runCourse';

export const initRunCourseState = (): RunCourseState => {
  return {
    sheets: [],
    routeOptions: {},
    kpRouteMap: {},
    activeRouteInfo: null,
    debugInfo: '',
    timeSpanSumDisplay: '',
    distanceSumDisplay: '',
  };
};

export const initRunCourseEditState = (): RunCourseEditState => {
  return {
    isNewRoute: false,
    editingRoute: {
      startRoadNameDisp: '',
      startTs: '',
    },
    showRouteEditModal: false,
    routeType: 'main_line',
  };
};

export const initRunCourseUiState = (): RunCourseUiState => {
  return {
    menuMode: '',
    showContextMenu: false,
    contextMenuPosition: {
      left: '0px',
      top: '0px',
    },
    showDebugInfo: false,
    showDebugInfoCounter: 0,
  };
};
